import { cn as i } from "../../../lib/shadcn/utils/utils.js";
import { jsx as s } from "react/jsx-runtime";
import { cva as c } from "class-variance-authority";
var l = c("inline-flex items-center border border-solid border-transparent px-3 py-1 text-[12px] leading-4 font-semibold", {
  variants: {
    variant: {
      default: "border-primary-300 bg-primary-100 text-primary-700",
      alert: "border-error-400 bg-error-200 text-error-700",
      success: "border-success-300 bg-success-100 text-success-800",
      warning: "border-warn-500 bg-warn-100 text-warn-800",
      info: "border-primary-800 bg-primary-800 text-white",
      neutral: "border-secondary-500 bg-secondary-200 text-secondary-800",
      dark: "border-secondary-900 bg-secondary-900 text-white",
      white: "border-secondary-300 bg-white text-secondary-900",
      red: "border-primary-600 bg-primary-600 text-white",
      infoBlue: "border-info-400 bg-info-50 text-info-800",
      "old-default": "bg-primary-100 text-primary-500",
      "old-alert": "bg-[oklch(0.97_0.02_59.39)] text-error-700",
      "old-success": "bg-success-100 text-success-600",
      "old-warning": "bg-warn-100 text-warn-600",
      "old-info": "bg-primary-800 text-white",
      "old-neutral": "bg-secondary-100 text-secondary-600",
      "old-dark": "bg-secondary-900 text-white",
      "old-white": "bg-white text-secondary-700",
      "old-red": "bg-primary-600 text-white",
      "old-infoBlue": "bg-info-50 text-info-200"
    },
    shape: {
      rounded: "rounded-full",
      pill: "rounded-[2px]",
      circle: "flex h-[18px] w-[18px] flex-col items-center justify-center rounded-[100px] px-2 py-0"
    }
  },
  defaultVariants: {
    variant: "default",
    shape: "rounded"
  }
}), b = ({ dataTestid: e, label: r, children: t, variant: a, shape: o = "rounded", className: d, ...n }) => /* @__PURE__ */ s("span", {
  "data-testid": e,
  ...n,
  className: i(l({
    variant: a,
    shape: o
  }), d),
  children: r !== void 0 ? r : t
});
b.displayName = "Badge";
export {
  b as Badge
};

//# sourceMappingURL=Badge.js.map